import Repository from '@/repositories/repository'

const SponsorshipRepository = {
  async getPageTypeOneBySlug(queryParams: any = {}, slug: string, templateType: string) {
    const params = {
      page: '1',
      page_size: '100',
      ...queryParams
    }

    return await Repository(templateType + '|' + slug, 'page', params)
  },
  async getSponsorshipOverview(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('sponsorships-overview', 'page', params)
  }
}

export default SponsorshipRepository
